module.exports = __webpack_public_path__ + "media/images/icons/roundedSuccessIcon-0e5e2c3b1a466613cd6b1ac80656db9b.svg";